import React from 'react';
import { useDispatch } from 'react-redux';
import { samlAssertionAction } from './SamlAssertionAction';
import { ActionType } from '../../core/redux/actionType';
import { Redirect, useLocation } from 'react-router-dom';
import { useRoutes } from '../../navigation/routes';
import { useError, useLoading } from '../../core/api/hooks';
import ProjectModal from '../../project/ProjectModal';
import { useAppState } from '../../core/redux/hooks';
import { parseQueryToKeyedStrings } from '../../navigation/module';
import { useMount } from '../../core/hooks/useMount';
import { PortalType } from '../../navigation/portalType';
import ReportRecipientRedirect from '../../reportRecipient/ReportRecipientRedirect';


type Props = {
  className?: string;
};

type queryProps = {
  email?: string;
  redirect? : string;
};

const SamlAssertionPage: React.FC<Props> = () => {
  const dispatch = useDispatch();

  const routes   = useRoutes();
  const location = useLocation();
  const queryObj = parseQueryToKeyedStrings<queryProps>(location.search);
  const redirect = queryObj.redirect || '';

  const loginError  = !!useError(ActionType.SamlAssertionRequest);
  const isLoggingIn = useLoading(ActionType.SamlAssertionRequest);

  const userInfo = useAppState(state => state.auth.currentUser);

  useMount(() => { dispatch(samlAssertionAction(queryObj.email)); });

  return (
    <div>
      {
        isLoggingIn && (
          <div>Redirecting...</div>
        )
      }
      {
        loginError && (
          <Redirect to={routes.SsoError} />
        )
      }
      {
        !!userInfo && userInfo.authenticated && redirect.toLowerCase() === PortalType.REPORT_RECIPIENT.toLowerCase() && (
          <ReportRecipientRedirect />
        )
      }
      {
        !!userInfo && userInfo.authenticated && (
          <ProjectModal />
        )
      }
    </div>
  );
};

export default SamlAssertionPage;
